// (function () {
//     'use strict';

//     angular.module("imApp").factory("selectReportService", [function () {
//         let service = {};

//         return service;
//     }]);
// })();
